<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		(importingEvent)="uploader.click()"
		[isExportable]="isExportable"
		(exportingEvent)="exportUsers()"
	></app-nav-gestion-donnees>

	<input hidden type="file" #uploader (change)="importUsers($event)" />

	<div class="row my-3">
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option *ngIf="users?.length >= 5" [value]="10">10</option>
						<option *ngIf="users?.length >= 10" [value]="25">25</option>
						<option *ngIf="users?.length >= 25" [value]="50">50</option>
						<option *ngIf="users?.length >= 50" [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-2 ms-lg-auto">
				<!-- <div class="dropdown" *ngIf="true">
					<a
						class="btn btn-secondary dropdown-toggle"
						profile="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtres
					</a>
				</div> -->
			</div>

			<div class="col-lg-4 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Nom(s), prénom(s)"
						[(ngModel)]="searchedInput"
					/>
				</div>
			</div>
		</div>
		<div *ngIf="!isMobile" class="row mt-3">
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('lastName')"
					>Nom
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('firstName')"
					>Prénom
					<span
						*ngIf="sortType === 'firstName' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'firstName' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('username')"
					>Nom d'utilisateur
					<span
						*ngIf="sortType === 'username' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'username' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-3">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('email')"
					>Email
					<span
						*ngIf="sortType === 'email' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'email' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('email')"
					>Rôle
				</span>
			</div>
			<div class="col-1">
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let user of users
						| filterUserByName: searchedInput
						| orderBy : sortType : sortOrder
						| paginate
						: {
								itemsPerPage: itemsPerPage,
								currentPage: currentPage
						}
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-lg-2 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Nom :</span>
					{{ user?.lastName}}
				</span>
				<span class="col-lg-2 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Prénom :</span>
					{{ user?.firstName}}
				</span>
				<span class="col-lg-2 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Nom d'utilisateur :</span>
					{{ user?.username}}
				</span>
				<span class="col-lg-3 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Email :</span>
					{{ user?.email}}
				</span>
				<span class="col-lg-2 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Rôle :</span>
					{{ user?.profile?.name}}
				</span>
				<span class="col-lg-1 col-12 limitLineSpan">
					<i
							[routerLink]="['/gestion/users', user.id]"
							profile="button"
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
					></i>
				</span>
			</div>
		</div>
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option *ngIf="users?.length >= 5" [value]="10">10</option>
						<option *ngIf="users?.length >= 10" [value]="25">25</option>
						<option *ngIf="users?.length >= 25" [value]="50">50</option>
						<option *ngIf="users?.length >= 50" [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>
